<template>
  <div v-html="content" style="padding: 10px;"></div>
</template>

<script>
import { getSupportParkingLot } from '@/common/api/helper'
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      content: ''
    }
  },
  created () {},
  mounted () {
    console.log("高保真打包验证")
    getSupportParkingLot().then(response => {
      if (response.data.code === 0) {
        this.content = response.data.data.data
      }
    })
  }
}
</script>

<style lang="scss" scoped>
</style>
